import React, { Suspense } from "react";
import ReactLoader from "./ReactLoader";

const LazyLoader = ({ children }) => {
  return <Suspense fallback={<ReactLoader />}>{children}</Suspense>;
};


export default LazyLoader;
